import { PLAN_TO_PRICE, type PlanType } from "../const/planConst";

export function hasConsumerPlan(profile?: { plan?: string | null } | null): boolean {
  return Boolean(profile?.plan && PLAN_TO_PRICE.has(profile.plan as PlanType));
}

/** Publishing entitlement is separate from whether billing has a plan to update. */
export function hasActiveConsumerSubscription(profile?: {
  plan?: string | null;
  subscriptionStatus?: string | null;
} | null): boolean {
  return profile?.subscriptionStatus === "active" && hasConsumerPlan(profile);
}
